import { arrayMove } from '@dnd-kit/sortable';

export interface Identified {
  id: number;
}

/** Moves one item to a new index. Never sorts: every other item keeps its place. */
export function moveItem<T extends Identified>(items: T[], id: number, toIndex: number): T[] {
  const from = items.findIndex((item) => item.id === id);
  if (from < 0) return items;
  const to = Math.max(0, Math.min(items.length - 1, toIndex));
  return from === to ? items : arrayMove(items, from, to);
}

/** The DOM id of a row, so a dialog can scroll a found item into view. */
export const orderRowId = (listId: string, itemId: number) => `${listId}-row-${itemId}`;
